import { render, staticRenderFns } from "./DownSide.vue?vue&type=template&id=adf98aa6&scoped=true&"
import script from "./DownSide.vue?vue&type=script&lang=js&"
export * from "./DownSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf98aa6",
  null
  
)

export default component.exports